import { styled } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import COLORS from '../../styles/theme/colors';

export const Wrap = styled('div')(({ theme }) => ({
  padding: '50px 30px',
  maxWidth: 800,
  width: '100%',
  margin: 'auto',

  '&>h1': {
    textAlign: 'center',
  },

  [theme.breakpoints.down('sm')]: {
    padding: '30px 20px',
  }
}));

export const ButtonRow = styled('div')(() => ({
  margin: '30px auto 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '15px',

  '& > a': {
    color: '#4F77DE',
    fontWeight: 'bold',
    textDecoration: 'none'
  }
}));

export const FormRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10,

  '&>div': {
    flex: 1,
    maxWidth: '50%'
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '&>div': {
      maxWidth: '100%',
      width: '100%'
    }
  }
}));

export const FormItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),

  '& .MuiInputLabel-root': {
    fontSize: 12,
    color: COLORS.textSecondColor,
    marginBottom: theme.spacing(0.5),
  },

  '& .MuiSelect-select': {
    padding: '11.5px 16px',
    borderRadius: 8
  },

  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    borderRadius: 8,
    color: COLORS.textSecondColor,

    '& input': {
      borderRadius: 8,
      color: COLORS.textSecondColor,
      padding: theme.spacing(1.3, 2),
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1
      }
    }
  }
}));
